<template>
  <div class="breadcrumb-container">
    <Breadcrumb class="custom-breadcrumb"  >
      <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"
        v-if="breadcrumbItems && breadcrumbItems.length > 0 && breadcrumbItems[0].machine"></WebSocket>
      <BreadcrumbItem v-for="item in breadcrumbItems" :key="item.name" :to="item.to" class="breadcrumb-item">
        <div class="breadcrumb-content menu-actions">
          <span class="breadcrumb-text">
            <template v-if="sideBar != ''">{{ getTranslation('k261') }}{{ item.title[1] }}&nbsp; {{getTranslation('u045')}}: {{ item.title[0] }}</template>
          </span>
          <div class="breadcrumb-actions">
            <template v-if="sideBar != '' && item.machine && (item.machine.state != 1 && item.machine.state != 4)">
              <div class="status-badge status-offline">
                <span class="status-text">{{ getTranslation('m036') }}</span>
              </div>
              <Button type="success" icon="md-link" class="action-btn online-btn" @click.stop.prevent="online(item.machine.id)"
                size="small">{{ getTranslation("l002") }}</Button>
            </template>
            <template v-else-if="sideBar != '' && item.machine && (item.machine.state == 1)">
              <div class="status-badge status-online">
                <span class="status-text">{{ getTranslation('m035') }}</span>
              </div>
              <Button type="warning" icon="md-power" class="action-btn offline-btn" @click.stop.prevent="offline(item.machine.id)"
                size="small">{{ getTranslation("m001") }}</Button>
            </template>
             <template v-else-if="sideBar != '' && item.machine && (item.machine.state == 4)">
              <div class="status-badge status-reconnecting">
                <span class="status-text">{{ getTranslation('m090') }}</span>
              </div>
              <Button type="error" icon="md-power" class="action-btn offline-btn" @click.stop.prevent="offline(item.machine.id)"
                size="small">{{ getTranslation("m001") }}</Button>
            </template>
            <template v-if="sideBar != ''">
              <Button type="error" icon="ios-warning-outline" class="warn-btn"
                @click.stop.prevent="showWanList(warnListData)" size="small" ghost>
                {{ getTranslation("l005") }}：{{ (warnListData && warnListData.alarms && warnListData.alarms.length) || 0 }}
              </Button>
            </template>
          </div>
        </div>
      </BreadcrumbItem>
    </Breadcrumb>    
    <WarnList v-model="visiableError" :propVisible="visiableError" :errorData="errorData"></WarnList>

  </div>
</template>

<script>
import { Breadcrumb, BreadcrumbItem,  Button } from 'view-design'
import { mapState, mapGetters } from 'vuex'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { postJsError } from '@/util/util.js'
import WebSocket from '@/components/WebSocket.vue';
import WarnList from '@/components/WarnList.vue';
export default {
  name: 'AppBreadcrumb',
  props: {
    sideBar: {
      type: String,
      default: ''
    },
  },
  components: {
    Breadcrumb, BreadcrumbItem, Button,WebSocket,WarnList
  },
  computed: {
    ...mapState(['breadcrumbItems']),
    ...mapGetters(['getTranslation']),
    ...mapState(['warnListData']),
    webSocketUrl() {
      return API_URL['webSocket'] + "?mac=" + this.$route.query.mac;
    },
  },
  data() {
    return {
      visiableError: false,
      errorData: {},
    }
  },
  methods: {
    online(id) {
      let url = API_URL["machineOnline"];
      let params = {
        id: id
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.setMachineState(1);
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    offline(id) {
      let url = API_URL["machineOffline"];
      let params = {
        id: id
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.setMachineState(0);
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    setMachineState(state) {
      if(this.breadcrumbItems.length>0){
        this.breadcrumbItems[0].machine.state = state;
        
        this.$store.commit('setBreadcrumbItems', [
          { title: this.breadcrumbItems[0].title, machine: this.breadcrumbItems[0].machine }
        ]);
      }
    },
    showWanList(data) {
      this.errorData = data
      this.visiableError = true;
    },   
    closeError() {
      this.visiableError = false;
    },
    receiveMessage(obj) {
      if (obj && obj.kind) {
        switch (obj.kind) {
          case 'warnList':
            if(obj.data.macId == this.breadcrumbItems[0].machine.id){              
              if (obj.data.clear) {              
                this.$store.commit('setWarnList', null);
              } else {
                this.$store.commit('setWarnList', obj.data);
              }
            }
            break;
          case 'state':
            if(this.breadcrumbItems.length>0){
              if(obj.data.macId == this.breadcrumbItems[0].machine.id){
                if (obj.data.offline === true) {
                  this.setMachineState(0)
                } else {
                    if (obj.data.netState === 0) {
                      this.setMachineState(4)
                    } else if (obj.data.netState === 1) {
                      this.setMachineState(1)
                    }
                  }
                }
            }
            break;
          default:
            break;
        }
      }
    },
  },

}
</script>
<style scoped>
.breadcrumb-container {
  margin: 10px 0; /* 减小外边距 */
}

.custom-breadcrumb {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  
}

.breadcrumb-content {
  display: flex;
  align-items: center;
  gap: 6px; /* 减小间隙 */
  height: 100%;
}

.breadcrumb-text {
  font-size: 14px;
  color: #515a6e;
  font-weight: normal;
  line-height: 1.2; /* 减小行高 */
}

.breadcrumb-actions {
  display: flex;
  align-items: center;
  gap: 6px; /* 减小间隙 */
}

.action-btn {
  font-size: 12px;
  padding: 0 8px; /* 减小左右内边距 */
  height: 24px; /* 减小按钮高度 */
  line-height: 20px; /* 调整行高匹配高度 */
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.online-btn {
  background-color: #19be6b;
  border-color: #19be6b;
  color: #fff;
}

.online-btn:hover {
  background-color: #16a85a;
  border-color: #16a85a;
}

.offline-btn {
  background-color: #ff9900;
  border-color: #ff9900;
  color: #fff;
}

.offline-btn:hover {
  background-color: #e68a00;
  border-color: #e68a00;
}

.status-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px; /* 减小内边距 */
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  min-width: 60px;
  height: 24px; /* 与按钮高度一致 */
}

.status-text {
  font-size: 12px;
  font-weight: 500;
}

.status-offline {
  background-color: #f8f8f9;
  color: #808695;
  border: 1px solid #dcdee2;
}

.status-online {
  background-color: #19be6b;
  color: #ffffff;
  border: 1px solid #19be6b;
}

.status-reconnecting {
  background-color: #ff9900;
  color: #ffffff;
  border: 1px solid #ff9900;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

.warn-btn {
  font-size: 12px;
  padding: 0 8px; /* 减小左右内边距 */
  height: 24px; /* 减小按钮高度 */
  line-height: 20px; /* 调整行高匹配高度 */
  border-color: #ed4014;
  color: #ed4014;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
}

.warn-btn:hover {
  background-color: #ed4014;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(237, 64, 20, 0.3);
}

/* Override default breadcrumb styles */
.custom-breadcrumb>>>.ivu-breadcrumb {
  line-height: 1.2; /* 减小面包屑整体行高 */
}

.custom-breadcrumb>>>.ivu-breadcrumb-item-separator {
  color: #c5c8ce;
  margin: 0 6px; /* 减小分隔符间距 */
}

.custom-breadcrumb>>>.ivu-breadcrumb-item-link {
  color: #515a6e;
  font-weight: normal;
  text-decoration: none;
}

.custom-breadcrumb>>>.ivu-breadcrumb-item-link:hover {
  color: #2d8cf0;
}

.custom-breadcrumb>>>.ivu-breadcrumb>span:last-child .ivu-breadcrumb-item-link {
  color: #17233d;
  font-weight: normal;
}
</style>